import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

const ConciliacionPrevia: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Conciliación Previa | Innotec Food Equipment</title>
        <meta name="description" content="Proceso de conciliación previa para la resolución de conflictos de Innotec Food Equipment S.L." />
      </Helmet>
      <div className="max-w-5xl mx-auto px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <h1 className="text-4xl font-bold mb-6 text-white">Conciliación Previa</h1>
          <div className="h-1 w-24 bg-[#FCAA0D]"></div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="prose prose-lg prose-invert max-w-none"
        >
            <div className="mb-8">
              <p>
                Para el caso que existan cuestiones relativas al cumplimiento o incumplimiento o interpretación de las condiciones de la compraventa, las partes se someten a un proceso de mediación previa de obligado cumplimiento y de carácter preceptivo para interponer cualquier otro tipo de reclamación, ya sea judicial o extrajudicial.
              </p>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-[#FCAA0D]">Procedimiento</h2>
              <p>El procedimiento será el siguiente:</p>

              <ol className="list-decimal pl-6 mb-4 space-y-4">
                <li>
                  <p>
                    El cliente formulará por escrito su queja o desacuerdo, expresando con claridad sus motivos y sus pretensiones mediante su envío a la siguiente dirección de correo electrónico: <a href="mailto:info@innotecfood.com" className="text-[#FCAA0D] hover:underline">info@innotecfood.com</a>
                  </p>
                </li>

                <li>
                  <p>
                    La empresa registrará a dicha reclamación y acusará recibo de la misma en plazo de una semana.
                  </p>
                </li>

                <li>
                  <p>
                    La empresa estudiará la motivación de la reclamación, así como sus circunstancias y tratará por todos los medios de llegar a una solución satisfactoria para ambas partes en el plazo máximo de seis meses.
                  </p>
                </li>

                <li>
                  <p>
                    Si tras las comunicaciones y negociaciones con el cliente, resulta imposible dar satisfacción a la reclamación o bien llegar a un acuerdo, la empresa enviará por escrito mediante correo electrónico al cliente, notificación en tal sentido. Solo a partir de este momento, el cliente estará facultado para emprender cualquier otra vía de reclamación.
                  </p>
                </li>

                <li>
                  <p>
                    Tanto Innotec como el cliente asumen su condición de empresarios y declaran no estar sometidos a la legislación de consumidores y usuarios y se obligan expresamente a someterse a este proceso previo de intento de solución de conflictos.
                  </p>
                </li>
              </ol>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-[#FCAA0D]">Información adicional</h2>
              <p>
                Este proceso de conciliación previa está diseñado para resolver de manera eficiente y amistosa cualquier desacuerdo que pueda surgir en relación con nuestros productos o servicios, evitando en la medida de lo posible la necesidad de recurrir a procedimientos judiciales más costosos y prolongados.
              </p>
              <p>
                Le recomendamos que, antes de iniciar este proceso, revise detenidamente nuestras <a href="/condiciones-generales" className="text-[#FCAA0D] hover:underline">condiciones generales</a> y nuestra <a href="/garantia" className="text-[#FCAA0D] hover:underline">política de garantía</a> para entender completamente sus derechos y obligaciones.
              </p>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-[#FCAA0D]">Compromiso de Innotec</h2>
              <p>
                En <strong>Innotec Food Equipment S.L.</strong>, nos comprometemos a tratar todas las reclamaciones con seriedad, profesionalidad y en el menor tiempo posible, buscando siempre la mejor solución para todas las partes implicadas.
              </p>
              <p>
                Nuestro objetivo es mantener relaciones comerciales duraderas basadas en la confianza mutua y la satisfacción de nuestros clientes.
              </p>
            </div>
        </motion.div>
      </div>
    </>
  );
};

export default ConciliacionPrevia;
